import { useEffect } from 'react';
import { useIsLowEndDeviceFromLocalStorage } from '../../../../hooks/local-storage/useIsLowEndDeviceFromLocalStorage';
import { useGetGlobalAppStateStoreState } from '../../../../stores/app/GlobalAppStateStore';
import { useSetDeviceContext } from './helperHooks/useSetDeviceContext';

/**
 * Syncs isLowEndDevice from localStorage to GlobalAppStateStore.
 * This is the single source of truth for syncing localStorage value to store.
 * Updates store.deviceContext.deviceInfo.isLowEndDevice when localStorage value changes.
 * Creates the deviceInfo entry if missing to ensure value is always available.
 */
export function useSyncDeviceCapabilitiesToStore() {
  const { value: isLowEndDeviceFromStorage } = useIsLowEndDeviceFromLocalStorage();
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const { setDeviceContext } = useSetDeviceContext();

  useEffect(() => {
    if (isLowEndDeviceFromStorage === undefined) {
      return; // Don't update if hook value is still loading
    }

    const currentDeviceInfo = getGlobalAppStateStoreState().deviceContext.deviceInfo;
    const currentIsLowEndDevice =
      currentDeviceInfo && 'isLowEndDevice' in currentDeviceInfo
        ? currentDeviceInfo.isLowEndDevice
        : undefined;

    // Only update if value has changed
    if (currentIsLowEndDevice === isLowEndDeviceFromStorage) {
      return;
    }

    // Preserve existing deviceInfo properties, update isLowEndDevice
    setDeviceContext({
      deviceInfo: {
        ...currentDeviceInfo,
        isLowEndDevice: isLowEndDeviceFromStorage,
      },
    });
  }, [isLowEndDeviceFromStorage, getGlobalAppStateStoreState, setDeviceContext]);
}
